<script lang="ts" setup>
import { CriteriaInstance } from "types/Checklist";
import { WordsToIgnoreService } from "~/classes/models/wordsToIgnore/wordsToIgnore.service";

const props = defineProps({
  criteriaInstance: {
    type: Object as PropType<CriteriaInstance>,
    required: true,
  },
  text: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const documentId = inject("documentId") as any;

const userDataStore = useAppUserDataStore();
const { isUserAdmin } = storeToRefs(userDataStore);

const isIgnoring = ref(false);
const ignoreWord = async () => {
  const uid = useCurrentUID();

  if (!uid) {
    return;
  }

  isIgnoring.value = true;

  const wordsToIgnore = await WordsToIgnoreService.getUserWordsToIgnore(uid);
  wordsToIgnore.words.push(props.text);
  await wordsToIgnore.save();

  isIgnoring.value = false;
  showReevaluateMessage.value = true;
};

const isIgnoringGlobally = ref(false);
const ignoreWordGlobally = async () => {
  isIgnoringGlobally.value = true;

  const wordsToIgnore = await WordsToIgnoreService.getSystemWordsToIgnore();
  wordsToIgnore.words.push(props.text);
  await wordsToIgnore.save();

  isIgnoringGlobally.value = false;
  showReevaluateMessage.value = true;
};

const showReevaluateMessage = ref(false);

const store = useResultsForCriteriaIdStore(documentId, props.criteriaInstance);

const reevaluate = () => {
  store.reevaluate();
};

const dismiss = () => {};
</script>

<template>
  <BasePopover :disabled="disabled" :delay="{ show: 0, hide: 0 }">
    <slot />
    <template #content>
      <div v-if="showReevaluateMessage != true" class="p-1">
        <BaseTextButton :show-spinner="isIgnoring" @click="ignoreWord">
          <span class="flex flex-row items-center justify-start w-full">
            <BaseIconAdd class="mr-2" size="20" />
            Add to custom dictionary
          </span>
        </BaseTextButton>
        <BaseTextButton
          v-if="isUserAdmin"
          :show-spinner="isIgnoringGlobally"
          @click="ignoreWordGlobally"
        >
          <span class="flex flex-row items-center justify-start w-full">
            <BaseIconAdd class="mr-2" size="20" />
            Add to dictionary
          </span>
        </BaseTextButton>
      </div>
      <div
        v-if="showReevaluateMessage"
        class="flex flex-col p-2 max-w-[250px] text-center pt-4"
      >
        Would you like to reevaluate the spelling errors?
        <div class="flex flex-row w-full items-center justify-center px-4 py-2">
          <BaseTextButton color="success" class="grow" @click="reevaluate()">
            Yes
          </BaseTextButton>
          <BaseTextButton v-close-popper color="danger" class="grow">
            No
          </BaseTextButton>
        </div>
      </div>
    </template>
  </BasePopover>
</template>

<style scoped></style>
